//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[],[[["refCsys","refObject","refExp"],"AddDatumCsys",{},3,0],[["olderName","newName"],"SetCsysName",{},2,0],[["csysName","refObject"],"SetReferenceObject",{},2,0],[["csysName","expFormula"],"SetExpressionFormula",{},2,0],[["csysName","refObject","refCsys"],"EditCsys",{},3,0],[["csysName"],"DeleteCsys",{},1,0],[["csysName"],"GetCsysByName",{R_:{csysTag:"CoordinateSystem"}},1,0],[["count","csysName"],"GetAllCsys",{},0,0],[["csys","csysName","refExp"],"SetAllCsys",{},3,0]],[]];
SPLM.Tooling.OffsetDatumCsysBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.OffsetDatumCsysBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.OffsetDatumCsysBuilder.ReferenceType = Object.freeze({
    "ReferenceObject" : "ReferenceObject", "ReferenceExpression" : "ReferenceExpression"});

export default SPLM;